export function groupOptions(items, groupKey) {
  const ungrouped = items.filter((item) => !item[groupKey])
  const buckets = items
    .filter((item) => item[groupKey])
    .reduce((acc, item) => {
      const group = item[groupKey]
      if (!acc[group]) acc[group] = { groupOption: null, options: [] }
      if (item.is_group_option) {
        acc[group].groupOption = item
      } else {
        acc[group].options.push(item)
      }
      return acc
    }, {})

  return {
    ungrouped,
    groups: Object.entries(buckets).map(([group, { groupOption, options }]) => ({
      group,
      groupOption,
      options
    }))
  }
}

export function chipLabel(item, { displayKey, groupKey, isGrouped }) {
  if (!item) {
    return ''
  }
  if (isGrouped && item[groupKey] && !item.is_group_option) {
    return `${item[displayKey]} - ${item[groupKey]}`
  }
  return item[displayKey]
}
